import * as React from "react";
import { Dropdown, Field, Option } from "@fluentui/react-components";
import { TicketStatus } from "../types/glpi";
import { TICKET_STATUS_LABELS } from "../types/glpiConstants";

/** Statuts proposés à la création d'un ticket (sans Clos). */
export const CREATE_TICKET_STATUS_OPTIONS: TicketStatus[] = [1, 2, 5];

interface Props {
  value: TicketStatus;
  onChange: (status: TicketStatus) => void;
  disabled?: boolean;
}

export function TicketStatusDropdown({ value, onChange, disabled }: Props): React.ReactElement {
  return (
    <Field label="Statut initial" hint="Par défaut : Attribué si un technicien est sélectionné.">
      <Dropdown
        disabled={disabled}
        value={TICKET_STATUS_LABELS[value]}
        selectedOptions={[String(value)]}
        onOptionSelect={(_, data) => {
          const v = Number(data.optionValue);
          if (v === 1 || v === 2 || v === 5) {
            onChange(v as TicketStatus);
          }
        }}
      >
        {CREATE_TICKET_STATUS_OPTIONS.map((s) => (
          <Option key={s} value={String(s)} text={TICKET_STATUS_LABELS[s]}>
            {TICKET_STATUS_LABELS[s]}
          </Option>
        ))}
      </Dropdown>
    </Field>
  );
}
